import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    TextField,
    Box,
    Stepper,
    Step,
    StepLabel
} from '@mui/material';
import { useState } from 'react';
import { useEffect } from 'react';
import { checkPermissionGet, rekycOtpSendApi, reKycOtpVerifyApi, reKycSubmitAPi } from 'utils/API/Merchant APIs/MerchantApiCalls';
import Spinner from '../LoadingSinner';
import { globalNotifyError, globalNotifySuccess } from 'views/utilities/AlertToast';
import { LoadingButton } from '@mui/lab';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from 'react-router';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import StoreIcon from '@mui/icons-material/Store';
import LoginIcon from '@mui/icons-material/Login';
import BadgeIcon from '@mui/icons-material/Badge';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ShopIcon from '@mui/icons-material/Shop'; // For Play Store button
import PropTypes from 'prop-types';
const ReKYCDialog = ({ isSso }) => {
    const navigate = useNavigate();
    const [otpLoading, SetOtpLoading] = useState({ sending: false, verifying: false });
    const [loadingPanSubmit, setLoadingPanSubmit] = useState(false);
    const [otpToken, setOtpToken] = useState('');
    const [otp, setOtp] = useState('');
    const [panImageBase64, setPanImageBase64] = useState('');
    const [panImageName, setPanImageName] = useState('');
    const [aadhaarFrontImageBase64, setAadhaarFrontImageBase64] = useState('');
    const [aadhaarFrontImageName, setAadhaarFrontImageName] = useState('');
    const [aadhaarBackImageBase64, setAadhaarBackImageBase64] = useState('');
    const [aadhaarBackImageName, setAadhaarBackImageName] = useState('');
    const [status, setStatus] = useState(null);
    const [guidelines, setGuidelines] = useState(null);
    const [whitelabelStatus, setWhitelabelStatus] = useState(false);
    const [openChecker, setOpenChecker] = useState(null);

    // Toggle this to switch between Mobile App Prompt and Original Logic
    const showMobilePrompt = true;

    useEffect(() => {
        getCheckPermissions();
        // eslint-disable-next-line
    }, []);

    //handlers>>>
    const onClose = () => {
        if (isSso) {
            return;
        }
        navigate('/merchant-home');
    };

    const handleImageUpload = (e, setImageBase64, setImageName) => {
        const file = e.target.files[0];
        if (file && (file.type === 'image/jpeg' || file.type === 'image/png') && file.size <= 500 * 1024) {
            const reader = new FileReader();
            reader.onload = () => {
                setImageBase64(reader.result); // Base64 string of the uploaded image
            };
            reader.readAsDataURL(file);
            setImageName(file.name);
        } else {
            globalNotifyError('Please upload a valid JPEG/PNG image not exceeding 500 KB.');
        }
    };

    const handlePanImageUpload = (e) => handleImageUpload(e, setPanImageBase64, setPanImageName);
    const handleAadhaarFrontImageUpload = (e) => handleImageUpload(e, setAadhaarFrontImageBase64, setAadhaarFrontImageName);
    const handleAadhaarBackImageUpload = (e) => handleImageUpload(e, setAadhaarBackImageBase64, setAadhaarBackImageName);

    //API calls>>>
    const sendOtpApiCall = async () => {
        SetOtpLoading({ sending: true, verifying: false });
        const response = await rekycOtpSendApi();
        if (response?.status === 200) {
            const phoneNo = response?.data?.phone;
            if (response?.data?.status) {
                globalNotifySuccess(`OTP has been sent to the contact number ${phoneNo} `);
                setGuidelines(null);
            }
        }
        SetOtpLoading({ sending: false, verifying: false });
    };

    const submitOtpApiCall = async () => {
        if (otp) {
            SetOtpLoading({ sending: false, verifying: true });
            const payload = { otp };
            const response = await reKycOtpVerifyApi(payload);
            if (response?.status === 200) {
                if (response?.data?.status) {
                    const token = response?.data?.token;
                    globalNotifySuccess(response?.data?.message);
                    setOtpToken(token);
                } else {
                    setOtpToken('');
                }
            } else {
                setOtpToken('');
            }
            SetOtpLoading({ sending: false, verifying: false });
        } else {
            globalNotifyError('Please enter a valid OTP to continue.');
        }
    };

    const submitPanUploadApiCall = async () => {
        if (panImageBase64) {
            setLoadingPanSubmit(true);
            let payload;
            if (isSso) {
                payload = {
                    rekyc_mandatory: true,
                    pan_image: panImageBase64,
                    aadhar_front: aadhaarFrontImageBase64,
                    aadhar_back: aadhaarBackImageBase64
                };
            } else {
                payload = {
                    token: otpToken,
                    pan_image: panImageBase64,
                    aadhar_front: aadhaarFrontImageBase64,
                    aadhar_back: aadhaarBackImageBase64
                };
            }

            const response = await reKycSubmitAPi(payload);
            if (response?.status === 200) {
                globalNotifySuccess('Details submitted successfully, Please wait for the approval.');
                getCheckPermissions();
            }
            setLoadingPanSubmit(false);
        } else {
            globalNotifyError('Please choose a pancard image before submission.');
        }
    };

    const getCheckPermissions = async () => {
        SetOtpLoading({ sending: true, verifying: false });
        const permissionResponse = await checkPermissionGet();
        if (permissionResponse?.status === 200) {
            const reKyc = permissionResponse?.data?.rekyc;
            const rekycStatus = permissionResponse?.data?.rekyc_status;
            const guidelines = permissionResponse?.data?.guidelines;
            const whitelabel = permissionResponse?.data?.whitelabel;
            setOpenChecker(reKyc);
            setWhitelabelStatus(whitelabel);
            setStatus(rekycStatus);
            if (isSso) {
                setOtpToken('sso_rekyc');
                setGuidelines(null);
            } else {
                setGuidelines(guidelines);
            }
        }
        SetOtpLoading({ sending: false, verifying: false });
    };

    // Additional Imports
    const MobileAppPromptContent = () => {
        const steps = [
            {
                label: 'Download App',
                description: 'Install our mobile app from Google Play Store.',
                icon: <StoreIcon />
            },
            {
                label: 'Login Securely',
                description: 'Sign in using your merchant credentials.',
                icon: <LoginIcon />
            },
            {
                label: 'Navigate to Re-KYC',
                description: 'Click on any services, you will be redirected to Re-KYC section.',
                icon: <BadgeIcon />
            },
            {
                label: 'Complete the Re-KYC process by submitting documents',
                description: 'Upload PAN, Aadhaar & Agent/Shop Photo to complete verification.',
                icon: <UploadFileIcon />
            }
        ];

        return (
            <Box sx={{ p: 1, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 4, alignItems: 'center' }}>
                {/* Visual Section: Stylized Mobile Phone */}
                <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Box
                        sx={{
                            width: 220,
                            height: 440,
                            bgcolor: '#1e88e5', // Blue theme
                            borderRadius: 4,
                            p: 1.5,
                            boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
                            position: 'relative',
                            display: 'flex',
                            flexDirection: 'column'
                        }}
                    >
                        {/* Phone Notch/Header */}
                        <Box sx={{ height: 20, width: '100%', display: 'flex', justifyContent: 'center', mb: 1 }}>
                            <Box sx={{ width: 60, height: 6, bgcolor: 'rgba(255,255,255,0.3)', borderRadius: 4 }} />
                        </Box>

                        {/* Phone Screen */}
                        <Box
                            sx={{
                                flex: 1,
                                bgcolor: '#fff',
                                borderRadius: 3,
                                overflow: 'hidden',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: 2,
                                textAlign: 'center'
                            }}
                        >
                            <Box
                                sx={{
                                    width: 60,
                                    height: 60,
                                    borderRadius: '50%',
                                    bgcolor: '#e3f2fd',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    mb: 2
                                }}
                            >
                                <SmartphoneIcon sx={{ fontSize: 35, color: '#1565c0' }} />
                            </Box>
                            <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', mb: 1 }}>
                                Complete Re-KYC
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                Simple & Safe
                            </Typography>

                            {/* Mock UI Elements */}
                            <Box sx={{ width: '80%', height: 8, bgcolor: '#f5f5f5', borderRadius: 4, mt: 3 }} />
                            <Box sx={{ width: '60%', height: 8, bgcolor: '#f5f5f5', borderRadius: 4, mt: 1 }} />
                            <Box sx={{ width: '70%', height: 8, bgcolor: '#f5f5f5', borderRadius: 4, mt: 1 }} />

                            {/* Floating Verification Shield */}
                            <Box sx={{ mt: 4 }}>
                                <VerifiedUserIcon sx={{ fontSize: 40, color: '#4caf50' }} />
                            </Box>
                        </Box>
                        {/* Phone Home Button Area */}
                        <Box sx={{ height: 15, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Box sx={{ width: 40, height: 4, bgcolor: 'rgba(255,255,255,0.3)', borderRadius: 2 }} />
                        </Box>
                    </Box>
                </Box>

                {/* Content Section: Steps & Action */}
                <Box sx={{ flex: 1.5 }}>
                    <Typography variant="h5" sx={{ mb: 1, fontWeight: 700, color: '#0d47a1' }}>
                        Re-KYC Required
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary', lineHeight: 1.6 }}>
                        To comply with the latest security standards, please complete your Re-KYC process using our official mobile
                        application.
                    </Typography>

                    <Stepper activeStep={-1} orientation="vertical" sx={{ mb: 3 }}>
                        {steps.map((step) => (
                            <Step key={step.label} expanded>
                                <StepLabel
                                    StepIconComponent={() => (
                                        <Box
                                            sx={{
                                                width: 32,
                                                height: 32,
                                                borderRadius: '50%',
                                                bgcolor: '#e3f2fd',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: '#1565c0'
                                            }}
                                        >
                                            {step.icon}
                                        </Box>
                                    )}
                                >
                                    <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>
                                        {step.label}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                        {step.description}
                                    </Typography>
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    <Button
                        variant="contained"
                        startIcon={<ShopIcon />} // Google Play Icon substitute
                        href="https://play.google.com/store/apps/details?id=com.aceware.ace_neo"
                        target="_blank"
                        sx={{
                            bgcolor: '#000', // Black for Play Store button look
                            color: '#fff',
                            textTransform: 'none',
                            px: 3,
                            py: 1.2,
                            borderRadius: 2,
                            '&:hover': {
                                bgcolor: '#333'
                            }
                        }}
                    >
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 1 }}>
                            <Typography variant="caption" sx={{ lineHeight: 1, color: '#ddd' }}>
                                GET IT ON
                            </Typography>
                            <Typography variant="subtitle1" sx={{ fontWeight: 'bold', lineHeight: 1, color: '#ddd' }}>
                                Google Play
                            </Typography>
                        </Box>
                    </Button>
                </Box>
            </Box>
        );
    };

    const getDialogContent = () => {
        if (showMobilePrompt) {
            return <MobileAppPromptContent />;
        }

        if (openChecker === 1) {
            switch (status) {
                case '':
                    return (
                        <>
                            {otpToken ? (
                                <>
                                    <Typography variant="body1" gutterBottom>
                                        {`${
                                            !isSso ? 'OTP Verified!' : ''
                                        } Please upload clear images of your PAN card and Aadhaar card (front and back).`}
                                    </Typography>

                                    {/* Image upload section with flex layout */}
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 2 }}>
                                        {/* PAN Card Upload */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Button variant="contained" component="label">
                                                Upload PAN Card
                                                <input type="file" accept="image/jpeg, image/png" hidden onChange={handlePanImageUpload} />
                                            </Button>

                                            {panImageBase64 ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Box
                                                        component="img"
                                                        src={panImageBase64}
                                                        alt="PAN card preview"
                                                        sx={{ width: 80, height: 50, objectFit: 'cover', border: '1px solid #ddd' }}
                                                    />
                                                    <Typography variant="body2" color="green">
                                                        {panImageName}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Typography variant="body2" color="text.secondary">
                                                    No PAN card image uploaded
                                                </Typography>
                                            )}
                                        </Box>

                                        {/* Aadhaar Front Upload */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Button variant="contained" component="label">
                                                Upload Aadhaar Front
                                                <input
                                                    type="file"
                                                    accept="image/jpeg, image/png"
                                                    hidden
                                                    onChange={handleAadhaarFrontImageUpload}
                                                />
                                            </Button>

                                            {aadhaarFrontImageBase64 ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Box
                                                        component="img"
                                                        src={aadhaarFrontImageBase64}
                                                        alt="Aadhaar front preview"
                                                        sx={{ width: 80, height: 50, objectFit: 'cover', border: '1px solid #ddd' }}
                                                    />
                                                    <Typography variant="body2" color="green">
                                                        {aadhaarFrontImageName}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Typography variant="body2" color="text.secondary">
                                                    No Aadhaar front image uploaded
                                                </Typography>
                                            )}
                                        </Box>

                                        {/* Aadhaar Back Upload */}
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                            <Button variant="contained" component="label">
                                                Upload Aadhaar Back
                                                <input
                                                    type="file"
                                                    accept="image/jpeg, image/png"
                                                    hidden
                                                    onChange={handleAadhaarBackImageUpload}
                                                />
                                            </Button>

                                            {aadhaarBackImageBase64 ? (
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                    <Box
                                                        component="img"
                                                        src={aadhaarBackImageBase64}
                                                        alt="Aadhaar back preview"
                                                        sx={{ width: 80, height: 50, objectFit: 'cover', border: '1px solid #ddd' }}
                                                    />
                                                    <Typography variant="body2" color="green">
                                                        {aadhaarBackImageName}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Typography variant="body2" color="text.secondary">
                                                    No Aadhaar back image uploaded
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>
                                </>
                            ) : guidelines ? (
                                <>
                                    <DialogContent>
                                        <div dangerouslySetInnerHTML={{ __html: guidelines }} />
                                    </DialogContent>
                                </>
                            ) : (
                                <>
                                    <Typography variant="body1" gutterBottom>
                                        Please complete your Re-KYC by entering the OTP sent to your registered mobile number.
                                    </Typography>
                                    <TextField
                                        onChange={(event) => {
                                            if (event.target.value.length <= 6) {
                                                setOtp(event.target.value);
                                            }
                                        }}
                                        label="Enter OTP"
                                        variant="outlined"
                                        fullWidth
                                        value={otp}
                                        margin="normal"
                                    />
                                </>
                            )}
                            <Spinner loading={otpLoading.sending} />
                        </>
                    );
                case 'pending':
                    return <Typography variant="body1">Your Re-KYC request has been submitted and is pending for approval.</Typography>;
                case 'rejected':
                    return (
                        <>
                            <Typography variant="body1">
                                Your Re-KYC submission was <span style={{ color: 'red', fontWeight: 'bold' }}>REJECTED</span>. Please
                                Re-Submit your details.
                            </Typography>
                            <Button onClick={() => setStatus('')}>RE-SUBMIT NOW</Button>
                        </>
                    );
                default:
                    return null;
            }
        }
        return null;
    };

    const getDialogTitle = () => {
        if (showMobilePrompt) {
            return 'Complete Re-KYC Process';
        }
        if (openChecker === 1) {
            return 'Complete Re-KYC Process';
        }
        return null;
    };

    const getDialogActions = () => {
        if (showMobilePrompt) {
            return (
                <DialogActions>
                    <Button onClick={onClose} color="inherit">
                        Close
                    </Button>
                </DialogActions>
            );
        }

        if (openChecker === 1 && status === '') {
            return otpToken ? (
                <DialogActions>
                    <LoadingButton loading={loadingPanSubmit} onClick={submitPanUploadApiCall} color="primary">
                        Submit
                    </LoadingButton>
                </DialogActions>
            ) : guidelines ? (
                <DialogActions>
                    <LoadingButton endIcon={<DoubleArrowIcon />} loading={otpLoading?.sending} onClick={sendOtpApiCall} color="primary">
                        PROCEED
                    </LoadingButton>
                </DialogActions>
            ) : (
                <DialogActions>
                    <Tooltip title="Back to home">
                        <IconButton onClick={() => navigate('/merchant-home')} aria-label="home">
                            <HomeIcon />
                        </IconButton>
                    </Tooltip>
                    <LoadingButton disabled={otp.length !== 6} loading={otpLoading?.verifying} onClick={submitOtpApiCall} color="primary">
                        Submit OTP
                    </LoadingButton>
                </DialogActions>
            );
        }
        return (
            <Tooltip title="Back to home">
                <IconButton onClick={() => navigate('/merchant-home')} aria-label="home">
                    <HomeIcon />
                </IconButton>
            </Tooltip>
        );
    };

    if (!openChecker) return null; // Don't render dialog if rekyc is not 1

    return (
        <Dialog
            open={!whitelabelStatus && openChecker === 1}
            onClose={onClose}
            fullWidth
            maxWidth="lg" // Adjust the width: 'sm', 'md', 'lg', 'xl', or 'false' for no max width
            sx={{ '& .MuiDialog-paper': { maxWidth: 'none' } }} // Further customize the width
        >
            <DialogTitle>
                <Typography variant="h4" fontWeight="bold" color="primary">
                    {getDialogTitle()}
                </Typography>
            </DialogTitle>
            <DialogContent>{getDialogContent()}</DialogContent>
            {getDialogActions()}
        </Dialog>
    );
};

export default ReKYCDialog;
ReKYCDialog.propTypes = {
    isSso: PropTypes.bool
};
